import React from 'react';

import styled from 'styled-components';

import { CHART_TYPE, DISPLAY_VALUES, ORIENTATION_TYPE } from 'constants/charts';

import Chart from '../Graph/Chart';
import { DATA_RANGE_TYPE } from '../Widget/constants';
import { useWidgetContext } from '../Widget/WidgetContext';

interface Props {
  data: any;
  valueDisplay?: number;
  comparisonTypeEnabled?: boolean;
}

const Container = styled.div`
  height: 100%;
`;

const GraphWidgetContentGraph = ({ data, valueDisplay, comparisonTypeEnabled }: Props) => {
  const { type, rangeType, orientationType } = useWidgetContext();
  const isColumn = orientationType === ORIENTATION_TYPE.VERTICAL;

  return (
    <Container>
      {rangeType === DATA_RANGE_TYPE.NOW && (
        <Chart
          widgetType={type}
          type={isColumn ? CHART_TYPE.COLUMN : CHART_TYPE.BAR}
          data={data?.sort((a: any, b: any) => b.value - a.value) ?? []}
          xField={isColumn ? 'community_name' : 'value'}
          yField={isColumn ? 'value' : 'community_name'}
          seriesField={'community_name'}
          valueDisplay={valueDisplay}
          comparisonTypeEnabled={comparisonTypeEnabled}
        />
      )}
      {rangeType === DATA_RANGE_TYPE.OVERTIME && (
        <Chart
          widgetType={type}
          type={CHART_TYPE.LINE}
          data={data}
          xField={'date'}
          yField={'value'}
          seriesField={'community_name'}
          valueDisplay={valueDisplay}
          comparisonTypeEnabled={comparisonTypeEnabled}
        />
      )}
      {rangeType === DATA_RANGE_TYPE.GROUPED && (
        <Chart
          widgetType={type}
          type={CHART_TYPE.COLUMN}
          data={data ?? []}
          xField={'group_by'}
          yField={'value'}
          seriesField={'community_name'}
          valueDisplay={valueDisplay}
          comparisonTypeEnabled={comparisonTypeEnabled}
        />
      )}
    </Container>
  );
};

export default GraphWidgetContentGraph;
